import { cn } from '#/shared/lib/utils'

interface BalanceCellProps {
  value: number
}

function formatBalance(value: number) {
  const abs = Math.abs(value).toLocaleString('en-US')
  if (value > 0) return `+$${abs}`
  if (value < 0) return `-$${abs}`
  return '$0'
}

export function BalanceCell({ value }: BalanceCellProps) {
  const color =
    value > 0
      ? 'text-green-600'
      : value < 0
        ? 'text-destructive'
        : 'text-gray-500'

  return (
    <div className="flex h-7 items-center">
      <span className={cn('text-sm', color)}>{formatBalance(value)}</span>
    </div>
  )
}
